<template>
    <div class="wrap">
      <myHead></myHead>
      <div class="banner">
        <img v-if="index_banner" :src="index_banner" width="1920" height="390" alt="">
      </div>
      <div class="main-content">
        <div class="msg-wrap">
          <div class="title"><i class="el-icon-bell"></i> 通知公告</div>
          <div class="msg-box">
            <div :class="msgScrolling?'msg-scroll':''" v-if="msgList.length > 0">
              <router-link :to="'/message?id='+msgOne.id">
                <a href="javascript:;" class="msg" v-if="msgOne">{{msgOne.name}}</a>
              </router-link>
              <router-link :to="'/message?id='+msgTwo.id">
                <a href="javascript:;" class="msg" v-if="msgTwo">{{msgTwo.name}}</a>
              </router-link>
            </div>
            <div v-else>
              <a href="javascript:;" class="msg">暂无公告</a>
            </div>
          </div>
        </div>
        <!-- section-one -->
        <div class="flex-cb section-one">
          <div class="content">
            <div class="section-title section-title-more">
              招标公告
              <router-link :to="'/bidding?s_type='+(channel1[0]?channel1[0].s_type:0)">
                <a href="javascript:;" class="more">查看更多 <i class="el-icon-d-arrow-right"></i></a>
              </router-link>
            </div>
            <ul class="data-list">
              <li v-for="(item,index) in channel1" :key="index">
                <router-link :to="'/bidding?s_type='+item.s_type+'&id='+item.id" class="flex-cb">
                    <div class="title">
                      {{item.name}}
                    </div>
                    <div class="subtitle"><span></span> <span class="time">{{item.create_at}}</span></div>
                </router-link>
              </li>
              <el-empty v-if="channel1.length==0" description="暂无数据"></el-empty>
            </ul>
          </div>
        </div>
        <div class="flex-cb section-one">
          <div class="content">
            <div class="section-title section-title-more">
              中标公告
              <router-link :to="'/bidding?s_type='+(channel2[0]?channel2[0].s_type:0)">
                <a href="javascript:;" class="more">查看更多 <i class="el-icon-d-arrow-right"></i></a>
              </router-link>
            </div>
            <ul class="data-list">
              <li v-for="(item,index) in channel2" :key="index">
                <router-link :to="'/bidding?s_type='+item.s_type+'&id='+item.id" class="flex-cb">
                    <div class="title">
                      {{item.name}}
                    </div>
                    <div class="subtitle"><span></span> <span class="time">
                        {{item.create_at}}</span></div>
                </router-link>
              </li>
              <el-empty v-if="channel2.length==0" description="暂无数据"></el-empty>
            </ul>
          </div>
        </div>
        <!-- section-two -->
        <div class="flex-cb section-two">
          <div class="content content-left">
            <div class="header">
              电子竞价平台栏目
              <router-link :to="'/platform?s_type='+(channel5.list[0]?channel5.list[0].s_type:0)">
                <a href="javascript;" class="more">查看更多 <i class="el-icon-d-arrow-right"></i></a>
              </router-link>
            </div>
            <div class="data">
              <div class="data-content">
                <ul class="data-list">
                  <li v-for="(item,index) in channel5.list" :key="index"><span class="title">{{item.name}}</span>
                    <router-link :to="'/platform?s_type='+item.s_type+'&id='+item.id">
                      <a class="btn btn-main btn-sm" href="javascript:;">进入</a>
                    </router-link>
                  </li>
                  <el-empty v-if="channel5.page.total==0" description="暂无数据"></el-empty>
                </ul>
                <div class="page-wrap" v-if="channel5.page.total>0">
                  <div class="fr">
                    <el-pagination :page-size="channel5.page.limit" layout="prev, pager, next"
                      :total="channel5.page.total" @current-change="channel5CurrentChange">
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-cb section-one">
          <div class="content">
            <div class="section-title section-title-more">
              更正公告
              <router-link :to="'/bidding?s_type='+(channel3[0]?channel3[0].s_type:0)">
                <a href="javascript:;" class="more">查看更多 <i class="el-icon-d-arrow-right"></i></a>
              </router-link>
            </div>
            <ul class="data-list">
              <li v-for="(item,index) in channel3" :key="index">
                <router-link :to="'/bidding?s_type='+item.s_type+'&id='+item.id" class="flex-cb">
                    <div class="title">
                      {{item.name}}
                    </div>
                    <div class="subtitle"><span></span> <span class="time">
                        {{item.create_at}}</span></div>
                </router-link>
              </li>
              <el-empty v-if="channel3.length==0" description="暂无数据"></el-empty>
            </ul>
          </div>
        </div>
        <div class="flex-cb section-one">
          <div class="content">
            <div class="section-title section-title-more">
              下载中心
              <router-link :to="'/download?s_type='+(channel4.list[0]?channel4.list[0].s_type:0)">
                <a href="JavaScript:;" class="more">查看更多 <i class="el-icon-d-arrow-right"></i></a>
              </router-link>
            </div>
            <ul class="data-list">
              <li v-for="(item,index) in channel4.list" :key="index">
                <a :href="item.attach_file_info.xurl" :download="item.attach_file_info.name" target="_blank"  class="flex-cb">
                  <div class="title">
                    {{item.name}}
                  </div>
                  <div class="subtitle"><span></span> <span class="time"> <a class="btn btn-main btn-sm" :href="item.attach_file_info.xurl" :download="item.attach_file_info.name" target="_blank" >下载</a></span></div>
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div class="flex-cb section-one">
          <div class="content">
            <div class="section-title section-title-more">
              帮助中心
              <router-link to="/help">
                <a href="javascript:;" class="more">查看更多 <i class="el-icon-d-arrow-right"></i></a>
              </router-link>
            </div>
            <ul class="data-list">
              <li v-for="(item,index) in helpList" :key="index">
                <router-link :to="'/help?id='+item.id"  class="flex-cb">
                  <a type="Title" href="javascript:;">{{item.name}}</a>
                </router-link>
              </li>
              <el-empty v-if="helpList.length==0" description="暂无数据"></el-empty>
            </ul>
          </div>
        </div>
        <!-- section-three -->
        <div class="flex-cb section-three">
          <a :href="item.url" v-for="(item,index) in sliderList" :key="index" :title="item.title">
                      <img fit="cover" :src="item.img" height="70" width="225"/>
                  </a>
        </div>
      </div>
      <myFoot></myFoot>
    </div>
  </template>
  
  <script>
    import Vue from 'vue';
    import myHead from '../../components/myHead/myhead';
    import myFoot from '../../components/myFoot/myfoot';
    import {
      mapActions,
      mapState,
      mapMutations
    } from "vuex";
  
    export default {
      name: "index",
      data() {
        return {
					index_banner:'',
          msgScrolling: false,
          msgList: [],
          msgOne: '',
          msgTwo: '',
          msgCurrent: 0,
          channel1: [],
          channel2: [],
          channel3: [],
          channel4: {
            page: {
              limit: 7,
              total: 0,
              pages: 1,
              current: 1
            },
            list: []
          },
          channel5: {
            page: {
              limit: 7,
              total: 0,
              pages: 1,
              current: 1
            },
            list: []
          },
          helpList: [],
                  sliderList: []
        }
      },
      components: {
        myHead,
        myFoot
      },
      mounted() {
				let that = this
        this.init()
				var itv = setInterval(function(){
					var company = localStorage.getItem('company')
					if(company){
						company = JSON.parse(company)
						that.index_banner = company.company_index_banner
						clearInterval(itv)
					}
				},50)
      },
      computed: {
      },
      created() {
      },
      methods: {
        ...mapActions({
          getMessageIndex: "index/getMessageIndex",
          getHomeChannel1: "index/getHomeChannel1",
          getHomeChannel2: "index/getHomeChannel2",
          getHomeChannel3: "index/getHomeChannel3",
          getHomeChannel4: "index/getHomeChannel4",
          getHomeChannel5: "index/getHomeChannel5",
          getHelpList: "index/getHelpList",
                  getSliderData: "index/getSliderData",
        }),
  
        init() {
          this.getMessageList()
          this.getChannel1()
          this.getChannel2()
          this.getChannel3()
          this.getChannel4()
          this.getChannel5()
          this.getHelp()
                  this.getSlider()
        },
        //通知公告
        getMessageList() {
          this.getMessageIndex({
            data: {},
            success: (res) => {
              if (res.code == 1) {
                this.msgList = res.data.list
                this.initMsgRoll()
              }
            },
          })
        },
        initMsgRoll() {
          let that = this
          let msgList = that.msgList
          let msgCurrent = that.msgCurrent
          let msgLen = msgList.length
          if (msgLen >= 2) {
            if (msgCurrent < msgLen - 1) {
              that.msgOne = msgList[msgCurrent]
              that.msgTwo = msgList[msgCurrent + 1]
              that.msgCurrent++
            } else {
              that.msgOne = msgList[msgCurrent]
              that.msgTwo = msgList[0]
              that.msgCurrent = 0
            }
          } else if (msgLen == 1) {
            that.msgOne = msgList[0]
            that.msgTwo = msgList[0]
          } else {
            return false
          }
          that.msgScrolling = false
          setTimeout(function() {
            that.msgScrolling = true
            setTimeout(function() {
              that.initMsgRoll()
            }, 1000)
          }, 1000)
        },
        //招标公告
        getChannel1() {
          this.getHomeChannel1({
            data: {},
            success: (res) => {
              if (res.code == 1) {
                this.channel1 = res.data.list
              }
            },
          })
        },
        //中标公告
        getChannel2() {
          this.getHomeChannel2({
            data: {},
            success: (res) => {
              if (res.code == 1) {
                this.channel2 = res.data.list
              }
            },
          })
        },
        //更正公告
        getChannel3() {
          this.getHomeChannel3({
            data: {},
            success: (res) => {
              if (res.code == 1) {
                this.channel3 = res.data.list
              }
            },
          })
        },
        //下载中心
        getChannel4() {
          this.getHomeChannel4({
            data: {
              page: this.channel4.page.current
            },
            success: (res) => {
              if (res.code == 1) {
                this.channel4 = res.data
              }
            },
          })
        },
        //电子竞价平台栏目
        getChannel5() {
          this.getHomeChannel5({
            data: {
              page: this.channel5.page.current
            },
            success: (res) => {
              if (res.code == 1) {
                this.channel5 = res.data
              }
            },
          })
        },
        channel5CurrentChange(current) {
          this.channel5.page.current = current
          this.getChannel5()
        },
        //帮助中心列表
        getHelp() {
          this.getHelpList({
            data: {},
            success: (res) => {
              if (res.code == 1) {
                this.helpList = res.data.list
              }
            },
          })
        },
              //友情链接
              getSlider() {
                this.getSliderData({
                  data: {keys:'link'},
                  success: (res) => {
                          console.log(res)
                    if (res.code == 1) {
                      this.sliderList = res.data
                    }
                  },
                })
              },
        download(item) { //下载文件
          let a = document.createElement('a')
          let url = item.attach_file_list.xurl
          fetch(url, {
            mode: 'no-cors'
          }).then(res => res.blob()).then(blob => {
            a.href = URL.createObjectURL(blob)
            a.download = item.attach_file_list.name
            a.click()
          })
        }
      }
    }
  </script>
  
  <style scoped>
    .banner {
      width: 1920px;
      margin: 0 auto;
    }
  
    .main-content .msg-wrap {
      margin-top: 23px;
      height: 44px;
      background: #fff;
      display: flex;
      justify-content: space-between;
    }
  
    .main-content .msg-wrap .title {
      display: inline-block;
      width: 112px;
      background: #0080FF;
      color: #fff;
      line-height: 44px;
      text-align: center;
    }
  
    .main-content .msg-wrap .msg-box {
      display: block;
      position: relative;
      width: 1100px;
      height: 44px;
      overflow: hidden;
    }
  
    .main-content .msg-wrap .msg-scroll {
      transition: all .5s;
      margin-top: -44px;
    }
  
    .main-content .msg-wrap .msg {
      vertical-align: top;
      line-height: 44px;
      margin-left: 25px;
      display: block;
      width: 1060px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;
    }
  
    /* 板块 */
  
    .main-content .section-one {
      margin-top: 23px;
      height: 340px;
    }
  
    .main-content .section-one .content {
      /* width: 592px; */
      width: 100%;
      height: 100%;
      background: #fff;
    }
  
    .content {
      box-shadow: 0 6px 10px 0 rgba(0, 0, 0, .1);
    }
  
    .main-content .section-title.section-title-more {
      text-align: left;
    }
  
    .main-content .section-title {
      position: relative;
      padding: 0 20px;
      height: 56px;
      color: #0080FF;
      font-size: 18px;
      font-weight: 700;
      line-height: 56px;
      background-image: linear-gradient(#f6f8fa, #d9e4f5);
      text-align: center;
    }
  
    .main-content .section-title.section-title-more .more {
      font-size: 1rem;
      position: absolute;
      right: 10px;
    }
  
    .main-content .section-one .content .data-list li {
      display: block;
      font-weight: 700;
      padding: 0 20px;
      border-bottom: 1px dashed rgba(0, 0, 0, .2);
      line-height: 22px;
    }
  
    .main-content .section-one .content .data-list li>a {
      position: relative;
      /* display: inline-block; */
      width: 100%;
      height: 50px;
    }
  
    .main-content .section-one .content .data-list li:last-child {
      border-bottom: none;
    }
  
    .main-content .section-one .content .data-list li>a .title {
      /* padding-top: 6px; */
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  
    .main-content .section-one .content .data-list li>a .subtitle {
      font-size: 12px;
      color: #cacaca;
    }
  
    .main-content .section-one .content .data-list li>a .subtitle .time {
      display: inline-block;
      /* position: absolute; */
      /* right: 0; */
    }
  
    .main-content .section-two {
      height: 470px;
      margin-top: 23px;
      background-color: #fff;
    }
  
    .main-content .section-two .content-left {
      height: 100%;
      /* width: 917px; */
      width: 100%;
      background: #fff;
    }
  
    .main-content .section-two .content-left .header {
      position: relative;
      color: #FFF;
      height: 55px;
      line-height: 55px;
      background: #0080FF;
      text-align: center;
      font-size: 18px;
      /* background: url(../../assets/images/bg-header2.png) no-repeat center, linear-gradient(180deg, #35a5f4 0, #196ae3 100%); */
    }
  
    .main-content .section-two .content-left .header .more {
      position: absolute;
      right: 30px;
      font-size: 1rem;
    }
  
    .main-content .section-two .content-left .data {
      position: relative;
      /* padding: 0 20px; */
			padding-right: 20px;
    }
  
    .main-content .section-two .content-left .data .data-content {
      display: inline-block;
      vertical-align: top;
      width: 100%;
    }
  
    .main-content .section-two .content-left .data .data-content .data-list {
      height: 366px;
    }
  
    .main-content .section-two .content-left .data .data-content .data-list li {
      position: relative;
      display: block;
      font-weight: 700;
      padding: 0 20px;
      border-bottom: 1px dashed rgba(0, 0, 0, .2);
    }
  
    .main-content .section-two .content-left .data .data-content .data-list li .title {
      vertical-align: top;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 50px;
      display: inline-block;
      width: 570px;
    }
  
    .main-content .section-two .content-left .data .data-content .data-list li .btn {
      position: absolute;
      right: 0;
      top: 12.5px;
      border-radius: 2px;
    }
  
    .main-content .section-two .content-left .data .data-content .page-wrap {
      position: relative;
      margin-top: 5px;
      height: 32px;
    }
  
    .main-content .section-two .content-right {
      height: 100%;
      width: 268px;
      background: #fff;
    }
  
    .main-content .section-two .content-right .data-list li {
      display: block;
      font-weight: 700;
      padding: 0 20px;
      border-bottom: 1px dashed rgba(0, 0, 0, .2);
    }
  
    .main-content .section-two .content-right .data-list li a {
      width: 100%;
      display: inline-block;
      line-height: 36px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  
    .main-content .section-two .content-right .data-list li:last-child {
      border-bottom: none;
    }
  
    li a:hover {
      color: #0080FF;
    }
  
    .main-content .section-three {
      margin-top: 30px;
      justify-content: space-around;
    }
  
    .main-content .section-three a {
      display: inline-block;
      width: 145px;
      height: 50px;
      background: #fff;
      -webkit-box-shadow: 0 4px 6px 0 rgba(0, 0, 0, .1);
      box-shadow: 0 6px 10px 0 rgba(0, 0, 0, .1);
    }
  
    .main-content .section-three a img {
      width: 145px;
      height: 50px;
    }
    
  </style>
  <style>
    .el-pager li.active{
      color: #0080FF;
    }
  </style>